import { render, staticRenderFns } from "./FiveEducationScreen.vue?vue&type=template&id=2f95a07f&scoped=true"
import script from "./FiveEducationScreen.vue?vue&type=script&lang=js"
export * from "./FiveEducationScreen.vue?vue&type=script&lang=js"
import style0 from "./FiveEducationScreen.vue?vue&type=style&index=0&id=2f95a07f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f95a07f",
  null
  
)

export default component.exports